function selectOriginalComponentVersion(state) {
  return state.component.data.originalVersion;
}

export { selectOriginalComponentVersion };
//# sourceMappingURL=data.original-version.js.map
